const menuMobile = document.querySelector('.nav-web');
const body = document.querySelector('body');
const idescargar_Public = {url: `${window.location.protocol}//${window.location.host}/wp-admin/admin-ajax.php`, postid: null}

/* Open Menu Mobile ES6 */
document.querySelector('#menu-btn').addEventListener('click', (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (menuMobile.classList.contains('open')) {
        body.classList.remove('shadow');
    } else {
        body.classList.add('shadow');
        menuMobile.classList.add('open');
        document.querySelector('.shadow').addEventListener('click', (e) => {
            if (e.target.tagName === 'BODY' || e.target.id === 'close-btn') {
                menuMobile.classList.remove('open');
                body.classList.remove('shadow');
            }
        })
    }
})

/* Open Search Mobile ES6 */
document.querySelector('#search-btn').addEventListener('click', (e) => {
    e.stopPropagation();
    e.preventDefault();
    let searchForm = document.querySelector('#searchForm')
    if (searchForm.classList.contains('hidden')) {
        searchForm.classList.add('show');
        searchForm.classList.remove('hidden');
        document.querySelector('#close-search').addEventListener('click', (e) => {
            searchForm.classList.add('hidden');
            searchForm.classList.remove('show');
        })
    } else {
        searchForm.classList.add('hidden');
        searchForm.classList.remove('show');
    }
})

/* SLIDER HOME */
if (document?.querySelectorAll('.card-feature')) {
    const items = document?.querySelectorAll('.card-feature');
    items?.forEach(item => {
        item?.addEventListener('click', () => {
            const link = item?.getAttribute('data-url');
            if (link) window.location.href = link;
        })
    })
}

/* RECOMMENDED CARD */
if (document?.querySelectorAll('.card-recommended')) {
    const items = document?.querySelectorAll('.card-recommended');
    items?.forEach(item => {
        item?.addEventListener('click', () => {
            const link = item?.getAttribute('data-url');
            if (link) window.location.href = link;
        })
    })
}

const assignClickActionToCardRegular = () => {
    const items = document?.querySelectorAll('.card-regular');
    items?.forEach(item => {
        item?.addEventListener('click', () => {
            const link = item?.getAttribute('data-url');
            if (link) window.location.href = link;
        })
    })
}

/* REGULAR CARD */
if (document?.querySelectorAll('.card-regular')) {
    assignClickActionToCardRegular();
}

/* POPULAR CARD */
if (document?.querySelectorAll('.card-popular')) {
    const items = document?.querySelectorAll('.card-popular');
    items?.forEach(item => {
        item?.addEventListener('click', () => {
            const link = item?.getAttribute('data-url');
            if (link) window.location.href = link;
        })
    })
}

/* LEFT SCROLL BUTTONS */
if (document?.querySelectorAll('.scroll-left')) {
    const items = document?.querySelectorAll('.scroll-left');
    items.forEach(item => {
        item.addEventListener('click', () => {
            if (document?.querySelector('.slider-home')) {
                document?.querySelector('.slider-home')?.scrollBy({
                    left: -600,
                    behavior: 'smooth'
                })
            }
        })
    })
}

/* RIGHT SCROLL BUTTONS */
if (document?.querySelectorAll('.scroll-right')) {
    const items = document?.querySelectorAll('.scroll-right');
    items.forEach(item => {
        item.addEventListener('click', () => {
            if (document?.querySelector('.slider-home')) {
                const slide = document?.querySelector('.slider-home')
                slide.scrollBy({
                    left: 600,
                    behavior: 'smooth'
                })
            }
        })
    })
}

/* SHOW MORE CONTENT ES6 */
if (document.querySelector('#show-more-content')) {
    addEventExpandButton(false)
}

/* LOAD YOUTUBE VIDEO ON USER CLICK */
if (document.querySelector('#yt-preview')) {
    ytButton = document.querySelector('#yt-preview');
    ytButton.addEventListener('click', () => {
        let ytid = ytButton.getAttribute('data-ytid');
        let frame = document.createElement('iframe');
        frame.frameBorder="0";
        frame.allowFullscreen = true;
        frame.allow="autoplay";
        frame.src=`https://www.youtube.com/embed/${ytid}?autoplay=1`;
        frame.style.height = '200px';
        frame.style.width = '355px';
        frame.style.borderRadius = '10px';
        ytButton.innerHTML = "";
        ytButton.appendChild(frame);
    })
}

function addEventExpandButton(isExpanded) {
    if (!isExpanded) {
        const expandButton = document.querySelector('#show-more-content');
        expandButton.addEventListener('click', () => {
            addDynamicHeightClass(true);
            expandButton.innerText = "Mostrar menos";
            expandButton.setAttribute('id', 'show-minus-content');
            addEventExpandButton(true)
        }, {passive: true})
    } else {
        const reduceButton = document.querySelector('#show-minus-content');
        reduceButton.addEventListener('click', (event) => {
            addDynamicHeightClass(false);
            reduceButton.setAttribute('id', 'show-more-content');
            reduceButton.innerText = "Mostrar más";
            addEventExpandButton(false)
        }, {passive: true})
    }
}

function addDynamicHeightClass(add) {
    const content = document.querySelector('article .content');
    if (content.scrollHeight < 1000) {
        if (add) {
            content.classList.add('open-1000');
        } else {
            content.classList.remove('open-1000')
        }
    } else if (content.scrollHeight < 1500) {
        if (add) {
            content.classList.add('open-1500');
        } else {
            content.classList.remove('open-1500')
        }
    } else if (content.scrollHeight < 2000) {
        if (add) {
            content.classList.add('open-2000');
        } else {
            content.classList.remove('open-2000')
        }
    } else if (content.scrollHeight < 2500) {
        if (add) {
            content.classList.add('open-2500');
        } else {
            content.classList.remove('open-2500')
        }
    } else if (content.scrollHeight < 3000) {
        if (add) {
            content.classList.add('open-3000');
        } else {
            content.classList.remove('open-3000')
        }
    } else if (content.scrollHeight < 3500) {
        if (add) {
            content.classList.add('open-3500');
        } else {
            content.classList.remove('open-3500')
        }
    } else if (content.scrollHeight < 4000) {
        if (add) {
            content.classList.add('open-4000');
        } else {
            content.classList.remove('open-4000')
        }
    } else if (content.scrollHeight < 4500) {
        if (add) {
            content.classList.add('open-4500');
        } else {
            content.classList.remove('open-4500')
        }
    } else if (content.scrollHeight < 5000) {
        if (add) {
            content.classList.add('open-5000');
        } else {
            content.classList.remove('open-5000')
        }
    } else if (content.scrollHeight < 5500) {
        if (add) {
            content.classList.add('open-5500');
        } else {
            content.classList.remove('open-5500')
        }
    } else if (content.scrollHeight < 6000) {
        if (add) {
            content.classList.add('open-6000');
        } else {
            content.classList.remove('open-6000')
        }
    } else if (content.scrollHeight < 6500) {
        if (add) {
            content.classList.add('open-6500');
        } else {
            content.classList.remove('open-6500')
        }
    } else {
        if (add) {
            content.classList.add('open-10000');
        } else {
            content.classList.remove('open-10000')
        }
    }
}

async function getData(order, term, page, tax) {
    const data = new FormData();
    data.append('action', 'action_sorting_post');
    data.append('order', order);
    data.append('term', term);
    data.append('page', page);
    data.append('tax', tax);
    let res = await fetch(idescargar_Public.url, {
        method: 'POST',
        body: data
    })
    return res;
}

/* FILTER FOR DEVELOPER, CATEGORY, TAXONOMY */
if (document.querySelectorAll('.sorting div label')) {
    const sortingTabs = document.querySelectorAll('.sorting div label');
    sortingTabs.forEach(sortingTab => {
        sortingTab.addEventListener('click', async () => {
            const mainLoop = document.querySelector('#main-loop');
            const order = sortingTab.getAttribute('for');
            const term = mainLoop.getAttribute('data-tax');
            const tax = mainLoop.getAttribute('data-name');
            const page = '';
            let res = await getData(order, term, page, tax);
            if (res.ok) {
                mainLoop.innerHTML = await res.text();
                if (document.querySelector('#load-more-ajax')){
                    document.querySelector('#load-more-ajax').addEventListener('click', loadMoreApps, {passive: true})
                }
                assignClickActionToCardRegular()
            }
        }, {passive: true})
    })
}

async function loadMoreApps() {
    const page = document.querySelector('#load-more-ajax')?.getAttribute('data-page'),
        term = document.querySelector('#main-loop')?.getAttribute('data-tax');
    let order = document.querySelector('.sorting div input[type=radio]:checked')?.getAttribute('id');
        if (!order) {
        order = 'new'
    }
    const tax = document.querySelector('#main-loop').getAttribute('data-name');
    let res = await getData(order, term, page, tax);
    if (res.ok) {
        const data = await res.text();
        document.querySelector('.show-more').remove();
        document.querySelector('#main-loop').innerHTML += data;
        if (document.querySelector('#load-more-ajax')){
            document.querySelector('#load-more-ajax').addEventListener('click', loadMoreApps);
        }
        assignClickActionToCardRegular()
    }
}

if (document.querySelector('#load-more-ajax')) {
    document.querySelector('#load-more-ajax').addEventListener('click', loadMoreApps, {passive: true})
}

if (document.querySelector('.count-dwn') && document.querySelector('.btn-retry')) {
    const button = document.querySelector('.btn-retry');
    setTimeout(() => {
        const link = button.getAttribute('data-link');
        button.addEventListener('click', () => {
            window.location.href = link
        })
        window.location.href = link;
    }, 5000);
}

if (document.querySelector('button#leave-comment')) {
    const button = document.querySelector('button#leave-comment');
    function func(event) {
        const commentsJS = document.createElement('script');
        commentsJS.src = "https://idescargar.com/wp-content/themes/appmarket/public/js/comments.js?ver=1.1.6";
        document.body.appendChild(commentsJS);
        button.removeEventListener('click', func);
    }
    button.addEventListener('click', func);
}

if (document.querySelector('button#search-load-more')) {
    const button = document.querySelector('button#search-load-more');
    button.addEventListener('click', async () => {
        const lastAppId = button.getAttribute('data-last');
        const searchTerm = button.getAttribute('data-s');
        const data = new FormData();
        data.append('action', 'action_search_load_more_results');
        data.append('last_app_id', lastAppId);
        data.append('search_term', searchTerm);
        let res = await fetch(idescargar_Public.url, {
            method: 'POST',
            body: data
        })
        if (res.ok) {
            const data = await res.json();
            const container = document.querySelector('div.search-results');
            data?.posts?.forEach(post => {
                const div = document.createElement('div');
                div.classList.add('card-regular');
                div.setAttribute('data-url', post.slug);
                const img = document.createElement('img');
                img.width = 100;
                img.height = 100;
                img.loading = 'lazy';
                img.alt = post.title + " icon";
                img.src = post.icon;
                const link = document.createElement('a');
                link.href = post.slug;
                link.title = post.title;
                link.innerText = post.title;
                div.appendChild(img);
                div.appendChild(link);
                container.appendChild(div);
            })
            if (!data?.next_page) {
                const button = document.querySelector('main>div:last-child');
                document.querySelector('main').removeChild(button);
            } else {
                const button = document.querySelector('#search-load-more');
                button.setAttribute('data-last', data?.posts?.[data?.posts?.length -1 ]?.id);
            }
        }
    })
}

const downloadButton = document.querySelector('#downloadButton');

if (downloadButton) {
    async function addNewDownloadCounter() {
        const response = await fetch(idescargar_Public.url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams({
                action: 'add_new_download_to_app',
                id: downloadButton.getAttribute('data-id')
            })
        });

        const result = await response.json();
    }
    downloadButton.addEventListener('click', async () => {
        await addNewDownloadCounter();
        downloadButton.disabled = true;
        const link = downloadButton.getAttribute('data-link');
        if (link.includes('http')) {
            window.open(link, '_blank');
            return;
        }
        const initialUrl = 'https://dwn.idescargar.com/descargas/dw/' + link;

        const buttonContent =downloadButton.querySelector('div.content');
        const buttonIcon =downloadButton.querySelector('div.btn-icons-box');
        if (buttonContent) {
            buttonContent.style.display = 'none';
        }
        if (buttonIcon) {
            buttonIcon.style.display = 'none';
        }

        const percentageText = document.createElement('span');
        percentageText.classList.add('percentage');
        percentageText.innerText = '0%';
        downloadButton.appendChild(percentageText);
        percentageText.style.display = 'flex';
        percentageText.style.alignItems = 'center';
        percentageText.style.justifyContent = 'center';

        const progressBar = document.createElement('div');
        progressBar.classList.add('progress-bar');
        downloadButton.appendChild(progressBar);

        try {
            const finalResponse = await fetch(initialUrl);

            if (!finalResponse.ok) {
                throw new Error('Error al descargar el archivo');
            }

            const contentLength = finalResponse.headers.get('content-length');
            if (!contentLength) {
                throw new Error('No se pudo determinar el tamaño del archivo');
            }

            const contentDisposition = finalResponse.headers.get('Content-Disposition');
            const match = contentDisposition.match(/filename="(.+?)"/);

            let filename = 'archivo.apk';

            if (match) {
                filename = match[1];
            }

            const totalBytes = parseInt(contentLength, 10);
            let receivedBytes = 0;

            const reader = finalResponse.body.getReader();
            const chunks = [];

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;

                chunks.push(value);
                receivedBytes += value.length;

                const progress = Math.floor((receivedBytes / totalBytes) * 100);
                progressBar.style.width = `${progress}%`;
                percentageText.innerText = `${progress}%`;
            }

            const blob = new Blob(chunks);
            const downloadUrl = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = downloadUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(downloadUrl);

            percentageText.innerText = '¡Descarga completa!';
            setTimeout(() => {
                progressBar.remove();
                percentageText.remove();
                buttonContent.style.display = 'flex';
                buttonIcon.style.display = 'flex';
                downloadButton.disabled = false;
            }, 2000);

        } catch (error) {
            percentageText.innerText = 'Error en la descarga. Inténtalo más tarde.';
            downloadButton.disabled = false;
        }
    });
}
